import { useEffect } from "react";
import { useSelector } from "react-redux";
import { getFlightDetailsSlice } from "../store/flightDetails/selectors.js";
import { getSearchResultsSlice } from "../store/searchResults/selectors.js";
import { carrierUtils, pricingUtils } from "@flights/web-api-utils-universal";
import { goal } from "@flights/et-universal";
import useEvents from "./useEvents.js";
const useTrackFlightDetailsPriceChangeGoal = () => {
    const flightDetails = useSelector(getFlightDetailsSlice);
    const searchResults = useSelector(getSearchResultsSlice);
    const { grumble } = useEvents();
    useEffect(() => {
        if (flightDetails.flight) {
            const flightDetailsFromSearchResults = searchResults.flights.find((flightItem) => flightItem.token == flightDetails.flight?.token);
            if (flightDetailsFromSearchResults) {
                const totalPrice = pricingUtils.priceToNumber(flightDetails.flight.priceBreakdown.total);
                const searchResultsTotalPrice = pricingUtils.priceToNumber(flightDetailsFromSearchResults.priceBreakdown.total);
                if (totalPrice != searchResultsTotalPrice) {
                    const marketingCarriers = carrierUtils
                        .getUniqueMarketingCarriers(flightDetails.flight.segments)
                        .map((c) => c.code);
                    const operatingCarriers = [
                        ...new Set(flightDetails.flight.segments.flatMap((s) => s.legs.map((l) => l.flightInfo?.carrierInfo?.operatingCarrier).filter(Boolean)))
                    ];
                    const searchResultsMarketingCarriers = carrierUtils
                        .getUniqueMarketingCarriers(flightDetailsFromSearchResults.segments)
                        .map((c) => c.code);
                    const carriersMatch = marketingCarriers.length === searchResultsMarketingCarriers.length &&
                        marketingCarriers.every((c) => searchResultsMarketingCarriers.includes(c));
                    goal("flights_flight_details_price_change");
                    grumble("flights_flight_details_price_change", {
                        search_results_price: searchResultsTotalPrice,
                        flight_details_price: totalPrice,
                        difference: totalPrice - searchResultsTotalPrice,
                        token: flightDetails.flight.token,
                        marketing_carriers: marketingCarriers,
                        operating_carriers: operatingCarriers,
                        search_results_marketing_carriers: searchResultsMarketingCarriers,
                        carriers_match: carriersMatch
                    });
                }
            }
        }
    }, [searchResults, flightDetails, grumble]);
};
export default useTrackFlightDetailsPriceChangeGoal;
